module.exports = __webpack_public_path__ + "img/car_tail.af47a33a.png";